export const SET_VIDEO = "SET_VIDEO";
export const HEADER_VIDEO = "HEADER_VIDEO";
// export const API_URL = "https://backend.hypha.clickysoft.us/public/api";
export const API_URL = "https://api.hyphametrics.com/api";
